import { createContext } from 'react';
import { MemoryStorage } from 'services/storage';

export const StorageContext = createContext<Storage>(new MemoryStorage());

export const { Provider: StorageProvider } = StorageContext;
